/**
 * Requires
 */

import $ from 'jquery'

/**
 * Initialisation
 */

export function initialise() {
  // find all links that open new windows (outbound links and pdfs)
  $(document).on('click', 'a[target="_blank"]', function(event) {
    if (event.currentTarget.getAttribute('data-performance-ticket')) processBookingEvent(event)
    if (event.currentTarget.getAttribute('data-layer-meta')) processCMSConfiguredEvent(event)

    const url = $(this).attr('href')
    if (url.match(/\/uploads\//)) {
      trackFileDownload(url)
    } else {
      trackOutboundClick(url)
    }
  })
}

function getExtension(url) {
  var urlParts = url.match(/\.([a-z0-9]{3,4})$/i)
  if (urlParts) {
    return urlParts[1]
  }
  return false
}

function trackFileDownload(url) {
  send({
    eventCategory: 'Download',
    eventAction: getExtension(url),
    eventLabel: url,
  })
}

function trackOutboundClick(url) {
  send({
    eventCategory: 'Outbound Link',
    eventAction: 'Click',
    eventLabel: url,
  })
}

function send(eventObject) {
  console.info('sending analytics event', eventObject)

  // original ga
  window.ga && window.ga('send', 'event', eventObject)

  // new gtag
  window.gtag &&
    window.gtag('event', eventObject.eventAction, {
      event_category: eventObject.eventCategory,
      event_label: eventObject.eventLabel,
      value: eventObject.eventValue,
    })
}

function processBookingEvent(event) {
  const target = event.currentTarget

  const eventObject = {
    performanceName: target.getAttribute('data-performance-name'),
    performanceVenue: target.getAttribute('data-performance-venue'),
    performanceType: target.getAttribute('data-performance-type'),
  }

  let eventType = null
  const url = target.getAttribute('href')

  // If we are on the Academy site we short circuit the event to the Academy
  const currentUrl = window.location.href
  if (currentUrl.includes('academy.queenslandballet.com.au') || currentUrl.includes('dev.qb-academy')) {
    return triggerEventBooking(eventObject, 'ACADEMY')
  }

  if (url.includes('qtix.com.au')) {
    eventType = 'QTIX'
  } else if (url.includes('purchase.queenslandballet.com.au')) {
    eventType = 'PURCHASE'
  }

  if (eventType === 'QTIX') {
    triggerEventBooking(eventObject, 'QTIX')
  } else if (eventType === 'PURCHASE') {
    triggerEventBooking(eventObject, 'PURCHASE')
  }
}

function processCMSConfiguredEvent(event) {
  const metaString = event.currentTarget.getAttribute('data-layer-meta')

  try {
    // Convert single quotes to double quotes for valid JSON
    const jsonString = metaString.replace(/'/g, '"')

    // Parse into an object
    const eventObject = JSON.parse(jsonString)

    // Send to dataLayer
    if (window.dataLayer) {
      console.log(`triggering custom booking event`, eventObject)
      window.dataLayer.push(Object.assign({}, eventObject))
    }
  } catch (error) {
    console.error('Error parsing data-layer-meta:', error)
  }
}

function triggerEventBooking(eventObject, type) {
  switch (type) {
    case 'QTIX':
      eventObject.event = 'booking_start_qtix'
      break
    case 'PURCHASE':
      eventObject.event = 'booking_start_qld'
      break
    case 'ACADEMY':
      eventObject.event = 'booking_start_academy'
      break
  }

  if (window.dataLayer && eventObject.event) {
    console.log(`triggering booking event - ${type}`, eventObject)
    window.dataLayer.push(eventObject)
  }
}
